import React from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button, Typography, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import i18next from 'i18next';
import moment from 'moment';
import { faCalendarAlt, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import StyledCheckbox from '../Checkbox/StyledCheckbox';

const StyledDateContainer = styled('div')({
    width: '100%',
    '& .drp': {
        width: 'max-content'
    },
    '& .calendarIcon': {
        marginRight: '3px',
        color: '#357ebd',
    },
    '& .containerStylesContainer': {
        marginLeft: 'auto',
    },
    '& .chevronIcon': {
        marginLeft: '7px',
        color: '#357ebd',
    },
    '& .containerStyles': {
        width: '100%',
    },
    '& .labelWrapper': {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
    },
    '& .label': {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },
    '& .foreverCheck': {
        marginTop: 0,
        marginLeft: 0,
    },
    '& .maxLength': {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    '& .errorDate': {
        margin: 0,
        textAlign: 'right',
        height: 0
    },
    '& .errorDateText': {
        color: 'red',
        fontSize: '10px',
        textAlign: 'left'
    },
    '& .checkLabel': {
        fontSize: 12
    },
    '& .outlinedDrpContainer': {
        position: 'relative',
        marginTop: 8,
    },
    '& .outlinedDrpLabel': {
        position: 'absolute',
        top: 0,
        left: 8,
        transform: 'translateY(-50%)',
        zIndex: 1,
        padding: '0 4px',
        background: '#fff',
        color: '#878787',
        fontSize: 12,
        lineHeight: 1,
        maxWidth: 'calc(100% - 16px)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    '& .outlinedDrpLabelError': {
        color: 'red',
    }
});

const StyledDrpButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'errorDate' && prop !== 'notched',
})(({ theme, errorDate, notched }) => ({
    width: '100%',
    height: '100%',
    border: '1px solid #E6EDF5',
    padding: '10px',
    margin: '5px 0px',
    marginTop: notched ? 0 : -15,
    justifyContent: 'flex-start !important',
    ...(errorDate && {
        borderColor: 'red'
    })
}));

class ReactDateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLang: i18next.language
        };
    }

    componentDidUpdate = () => {
        if (i18next.language !== this.state.currentLang) {
            this.setState({
                currentLang: i18next.language,
            });
        };
    }

    render() {
        const { t, sameDate = false, headerStyle, singleDayToggle, date, customContainerStyle,
            customClass, label, description, disabled = false, onForever = false,
            forever = false, foreverLabel = 'Forever', isEmpty = false, format = "MM-DD-YYYY", timePicker = false,
            outlinedLabel = false, onApply, onHide, autoApply = true, errorMessage, ...other } = this.props;

        let customClassAUX = typeof customClass !== undefined ? customClass : '';
        let containerStylesAUX = typeof customContainerStyle !== undefined ? customContainerStyle : '';

        let locale = {
            format: format,
            search: 'Filtrer',
            daysOfWeek: moment.weekdaysShort(),
            monthNames: moment.months(),
        };
        let button = (
            <StyledDrpButton disabled={disabled} notched={outlinedLabel} errorDate={sameDate || isEmpty || !!errorMessage} className={clsx(customClassAUX)}>
                <div className="pull-left">
                    <FontAwesomeIcon className="calendarIcon" icon={faCalendarAlt} />
                    <span>
                        {forever ? foreverLabel : date}
                    </span>
                </div>
                <div className={clsx("containerStylesContainer", "pull-right")}>
                    <FontAwesomeIcon className="chevronIcon" icon={faChevronDown} />
                </div>
            </StyledDrpButton>
        )

        const picker = disabled ? button : (
            <DateRangePicker
                key={'_' + Math.random().toString(36).substr(2, 9)}
                className="drp"
                initialSettings={{
                    autoApply: autoApply,
                    applyClass: 'singleDatePicker',
                    locale: locale,
                    alwaysShowCalendars: false,
                    containerClass: clsx("containerStyles", containerStylesAUX),
                    timePicker: timePicker,
                    ...other,
                }}
                onApply={onApply}
                onHide={onHide}
            >
                {button}
            </DateRangePicker>
        );

        return (
            <React.Fragment>
                <StyledDateContainer>
                    {!outlinedLabel && label ?
                        <div className={clsx("labelWrapper", headerStyle)}>
                            <Typography className="label">{label}</Typography>
                        </div>
                        : ''}
                    {singleDayToggle}
                    {description ?
                        <div className="labelWrapper">
                            <Typography className="label" >{description.slice(0, 55)}</Typography>
                        </div>
                        : ''}
                    {outlinedLabel ?
                        <div className="outlinedDrpContainer">
                            {label ?
                                <Typography component="span" className={clsx("outlinedDrpLabel", (sameDate || isEmpty || !!errorMessage) && "outlinedDrpLabelError")}>{label}</Typography>
                                : null}
                            {picker}
                        </div>
                        : picker
                    }
                    {sameDate
                        ? <p className="errorDate"><small className="maxLength">*Minimun range allowed is 1 day</small></p>
                        : errorMessage
                            ? <p className="errorDateText">{errorMessage}</p>
                            : null}
                    {onForever && <FormControlLabel
                        className="foreverCheck"
                        control={
                            <StyledCheckbox
                                checked={forever}
                                onClick={onForever}
                                small={true}
                            />}
                        label={<span className="checkLabel">{foreverLabel}</span>}
                    />}
                </StyledDateContainer>
            </React.Fragment>
        );
    }
}

export default withTranslation('common')(ReactDateRangePicker);